/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 15. 通話できる空間共有 */
export const template15 = {
  title: t.to('空間共有（通話可能）', 'title15'),
  desc: t.to(
    'シーンの設定を空間共有（通話可能）にして、カメラブロックを使うことで他の人と一緒に入れる空間をつくることができます。URLを他の人に共有すると同じ空間に入ることができます。',
    'desc15'
  ),
  img: '../public/template/15.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="250" y="170">
    <field name="is_init">on</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="environment_v2">
        <field name="environment">preset:forest</field>
        <next>
          <block type="a-camera_v2.1">
            <field name="position-x">0</field>
            <field name="position-y">1.7</field>
            <field name="position-z">4</field>
            <field name="avator_type">teat_Avatar_ver2.glb</field>
            <field name="click_type">cursor</field>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>`,
};
